export default function() {
    document.querySelectorAll('.toggle-input').forEach(function(toggle_element) {
        toggle_element.addEventListener('change', function(event) {
            if(event.target.checked) {
                this.parentElement.classList.add('-active');
                this.parentElement.querySelector('span').classList.replace('translate-x-0', 'translate-x-5');
            }else {
                this.parentElement.classList.remove('-active');
                this.parentElement.querySelector('span').classList.replace('translate-x-5', 'translate-x-0');
            }
        });
    });
}
